'use strict';
var baseUrl = window.location.origin + '/on/demandware.store/Sites-pacsun-Site/default';
var $ = require('jquery');
/**
 *
 * @returns {boolean} is user logged in
 */
function isLoggedIn() {
    if (window.utag_data && window.utag_data.page_name === 'checkout') {
        return $('.js-account-logout').is('*');
    }
    return $('.logged-in-acct-icon').is('*');
}

/**
 *
 * @returns {number} cart quantity
 */
function getCartQty() {
    var cartQty = 0;
    if ($('.minicart .minicart-quantity').length) cartQty = parseInt($('.minicart .minicart-quantity').text(), 10);
    else if ($('.product-summary-items-count').length) cartQty = parseInt($('.product-summary-items-count').text(), 10);
    return cartQty;
}

/**
 * @param {*} data
 * Save tokens in Local Storage
 */
function saveTokens(data) {
    if (data && data.access_token) {
        localStorage.setItem('slas_access_token', data.access_token);
        localStorage.setItem('slas_refresh_token', data.refresh_token || '');
        localStorage.setItem('slas_expires_in', Date.now() + (data.expires_in * 1000));
        if (data.refresh_token_expires_in) {
            localStorage.setItem('slas_refresh_expires_in', Date.now() + (data.refresh_token_expires_in * 1000));
        }
    }
}

/**
* Clear tokens
*/
function clearTokens() {
    localStorage.removeItem('slas_access_token');
    localStorage.removeItem('slas_refresh_token');
    localStorage.removeItem('slas_expires_in');
    localStorage.removeItem('slas_refresh_expires_in');
}

/**
 * Get the Guest Access Token
 * @returns {data} Token
 */
function getGuestToken() {
    var controllerUrl = baseUrl + '/SLASToken-Guest';
    return $.ajax({
        url: controllerUrl,
        method: 'GET'
    }).done(function (data) {
        if (data && !data.error) {
            saveTokens(data);
            if (window.bridgeWebSDK) {
                window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isNotLoggedIn);
            }
        }
    }).fail(function () {
        window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isNotLoggedIn);
    });
}

/**
 * Get the session-bridge token
 * @returns {data} Data
 */
function getBridgeToken() {
    var controllerUrl = baseUrl + '/SLASToken-SessionBridge';
    return $.ajax({
        url: controllerUrl,
        method: 'GET'
    }).done(function (data) {
        if (data && !data.error) {
            saveTokens(data);
            if (window.bridgeWebSDK) {
                window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isLoggedIn);
            }
        } else if (window.bridgeWebSDK) {
            window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.loginError);
        }
    }).fail(function () {
        if (window.bridgeWebSDK) {
            window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.loginError);
        }
    });
}

/**
 * Get stored access token
 * @returns {Token} Token
 */
function getAccessToken() {
    return localStorage.getItem('slas_access_token');
}

/**
 * Check if access token is expired
 * @returns {boolean} Boolean
 */
function isAccessTokenExpired() {
    var expiresAt = localStorage.getItem('slas_expires_in');
    return !expiresAt || Date.now() > expiresAt;
}

/**
 * Check if refresh token is expired
 * @returns {boolean} true or false
 */
function isRefreshTokenExpired() {
    var refreshExpiresAt = localStorage.getItem('slas_refresh_expires_in');
    return !refreshExpiresAt || Date.now() > refreshExpiresAt;
}

/**
 * Redirect user to login page
 */
function redirectToLogin() {
    clearTokens();

    // Notify BridgeSDK that user is logged out
    if (window.bridgeWebSDK) {
        window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isNotLoggedIn);
    }

    // Force redirect to SFCC login page
    window.location.href = '/on/demandware.store/Sites-pacsun-Site/en_US/Login-Show';
}

/**
 * Refresh the access token using the refresh token
 */
function refreshAccessToken() {
    var refreshTokenVal = localStorage.getItem('slas_refresh_token');
    var controllerUrl = baseUrl + '/SLASToken-Refresh';
    if (!refreshTokenVal) {
        redirectToLogin();
        return;
    }

    $.ajax({
        url: controllerUrl,
        method: 'POST',
        data: { refresh_token: refreshTokenVal }
    }).done(function (data) {
        if (data && !data.error) {
            saveTokens(data);
            if (isLoggedIn()) {
                if (window.bridgeWebSDK) {
                    window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isLoggedIn);
                }
            } else if (window.bridgeWebSDK) {
                window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isNotLoggedIn);
            }
        } else if (data && data.refreshExpired) {
            redirectToLogin();
        }
    }).fail(function () {
        window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.loginError);
    });
}

/**
 * Init auth flow
 * @returns {Token} Token
 */
function initSLASToken() {
    // Case 1 - No Token -> Get the guest token
    if (!getAccessToken()) {
        return getGuestToken();
    }

    // Case 2: Refresh token expired → force logout
    if (isRefreshTokenExpired()) {
        return redirectToLogin();
    }

    // Case 3: Access token expired → try refresh
    if (isAccessTokenExpired()) {
        return refreshAccessToken();
    }


    return '';
}


module.exports = function () {
    if (window.bridgeWebSDK) {
        initSLASToken();
    }

    $('body').on('event:LoginSuccess event:RegisterSuccess', function () {
        if (window.bridgeWebSDK) {
            getBridgeToken();
        }
    });

    if (window.bridgeWebSDK) {
        if (isLoggedIn()) {
            window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isLoggedIn);
        } else {
            window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isNotLoggedIn);
        }
        window.bridgeWebSDK.setCartValue(getCartQty());
    }

    $('body').on('event:LoginFail', function () {
        if (window.bridgeWebSDK) window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.loginError);
    });

    $('body').on('event:AddToCart', function () {
        if (window.bridgeWebSDK) window.bridgeWebSDK.setCartValue(getCartQty());
    });

    $('body').on('cart:update', function () {
        if (window.bridgeWebSDK) window.bridgeWebSDK.setCartValue(getCartQty());
    });

    $('body').on('event:LogoutSuccess', function () {
        if (window.bridgeWebSDK) {
            clearTokens();
            getGuestToken();
            window.bridgeWebSDK.setCurrentLoginState(window.bridgeWebSDK.loginStates.isNotLoggedIn);
        }
    });
};
